// extracted by mini-css-extract-plugin
export default {"dfooter":"Footer_dfooter__teSmw","dfooter_wrapper":"Footer_dfooter_wrapper__QLnih","dfooter_icons":"Footer_dfooter_icons__PJTzY"};